let forms = {
   add_pump_attendant: {
      icon: 'fa fa-users',
      title: 'Add Pump Attendant',
      subtitle: 'Provide pump attendant details',
      forms: [
         {
            type: 'text', form_type: 'text', class: 'col-12 col-md-6', model: 'firstName',
            validation: 'required|min:3|max:50', label: 'First Name',
         },
         {
            type: 'text', form_type: 'text', class: 'col-12 col-md-6', model: 'lastName',
            validation: 'required|min:3|max:50', label: 'Last Name',
         },
         {
            type: 'text', form_type: 'text', class: 'col-12', model: 'dealerNames',
            validation: 'required|min:3|max:150', label: 'Dealer Names',
         },
         {
            type: 'mobile', form_type: 'text', class: 'col-12', model: 'mobileNumber',
            validation: 'required', label: 'Mobile Number',
         },
         {
            type: 'text', form_type: 'text', class: 'col-12 col-md-6', model: 'idNumber',
            validation: 'required|min:3|max:50', label: 'ID Number',
         },
         {
            type: 'select', class: 'col-12 col-md-6', model: 'station', filterable: true, clearable: true,
            multiple: false, max_tag_count: 1, options: [], validation: 'required', label: 'Station'
         },
      ]
   },
   edit_pump_attendant: {
      icon: 'fa fa-users',
      title: 'Edit Pump Attendant',
      subtitle: 'Provide pump attendant details',
      forms: [
         {
            type: 'text', form_type: 'text', class: 'col-12', model: 'csaName',
            validation: 'required|min:3|max:50', label: 'Name',
         },
         {
            type: 'text', form_type: 'text', class: 'col-12 col-md-6', model: 'idNumber',
            validation: 'required|min:3|max:50', label: 'ID Number',
         },
         {
            type: 'text', form_type: 'text', class: 'col-12 col-md-6', model: 'dealerName',
            validation: 'required|min:3|max:150', label: 'Dealer Names',
         },
         // {
         //    type: 'select', class: 'col-12 col-md-6', model: 'station', filterable: true, clearable: true,
         //    multiple: false, max_tag_count: 1, options: [], validation: 'required', label: 'Station'
         // },
      ]
   },
   upload_pump_attendant: {
      icon: 'fa fa-upload',
      title: 'Upload Pump Attendants',
      subtitle: 'Provide file containing pump attendants',
      forms: [
         {
            type: 'upload', class: 'col-12 big-upload', model: 'attendants', validation: 'required', label: 'Pump Attendants',
            accept: '.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel', multiple: false
         },
      ]
   },
}

let tables = {
   attendants: {
      icon: 'fa fa-users',
      title: 'Pump Attendants',
      table_fields: [
         { name: 'ID Number', align: 'l' },
         { name: 'CSA Names', align: 'l' },
         { name: 'Dealer Names', align: 'l' },
         { name: 'Mobile Number', align: 'l' },
         { name: 'Station', align: 'l' },
         { name: 'Promo Code', align: 'l' },
         { name: 'Created At', align: 'c' },
         { name: 'Actions', align: 'c' }  
      ],
      search_fields: ["idNumber", "csaName", "dealerName", "mobileNumber", "station","promoCode"],
      row_data: [
         { type: 'text', field: 'idNumber', class: 'bold' },
         { type: 'text', field: 'csaName', class: 'bold' },
         { type: 'text', field: 'dealerName', class: 'bold' },
         { type: 'text', field: 'mobileNumber', class: 'bold' },
         { type: 'text', field: 'station', class: 'bold' },
         { type: 'text', field: 'promoCode', class: 'bold' },
         { type: 'date', field: 'createdDate', class: 'center bolder small', format: 'DD-MM-YYYY HH:mm' },
         {
            type: 'action', field: 'name', class: 'center', icon: '', actions: [
               // {type: 'title', title: 'Actions'},
               { type: 'menu', title: 'Edit', event: 'attendant:edit', icon: 'fa-edit' },
               { type: 'menu', title: 'Delete', event: 'attendant:delete', icon: 'fa-trash-alt' },
            ]
         },
      ]
   },
}

export default {
   forms: utils.generateAllFormData(forms),
   tables
}